module.exports = __webpack_public_path__ + "img/customer-ico.ef80ee71.png";